import { render, staticRenderFns } from "./CommissionStatusBlock.vue?vue&type=template&id=1461f69c&"
import script from "./CommissionStatusBlock.vue?vue&type=script&lang=js&"
export * from "./CommissionStatusBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports